import * as _ from "lodash";
import { IExportOptions, IExportRequestPayload, IExportServiceClient } from "./PA.Export.IF";
import { IMetricParameterSet } from "../PA.Metric.Services/PA.Metrics.IF";
import { PAEnvironment } from "../PA.Core/PAEnvironment";
import axios from "axios";
import { BehaviorSubject } from "rxjs";
import { PAMetricUtils } from "../PA.Metric.Services/PAMetricUtils";
import { ICubePerspective, ICubePerspectiveOptions, ICubeSource } from "../PA.HyperRectangle.Core/PA.HyperRectangle.IF";
import { IHRTableModelOptions } from "../../client-ui5/PA-Controls/HyperRectangleTableModels";
import { CubeSourceDataService, ICubeSourcePerspectiveData } from "../PA.HyperRectangle.Services/CubeSourceDataService";

export class PAExport implements IExportServiceClient {
    private _OnExportCompleted: BehaviorSubject<IExportServiceClient>;

    constructor() {
        this._OnExportCompleted = new BehaviorSubject<IExportServiceClient>(this);
    }

    get OnExportCompleted(): BehaviorSubject<IExportServiceClient> {
        return this._OnExportCompleted;
    }

    async exportJSON(json: any, aExportOptions: IExportOptions): Promise<number> {
        const self = this;
        return await self.makeRequest("exportJSON", aExportOptions, json);
    }

    async exportMetrics(aMetricParamSet: IMetricParameterSet, aExportOptions: IExportOptions): Promise<number> {
        const self = this;
        await PAMetricUtils.staticMetricParameterSet_preProcess(aMetricParamSet);
        return await self.makeRequest("exportMetrics", aExportOptions, undefined, aMetricParamSet);
    }

    async exportSnapshotDetails(aExportOptions: IExportOptions): Promise<number> {
        const self = this;
        return await self.makeRequest("exportSnapshotDetails", aExportOptions);
    }

    async exportPerspectives(
        perspective: ICubePerspective,
        tableOptions: IHRTableModelOptions,
        options: IExportOptions,
    ): Promise<number> {
        const self = this;
        const pd = await CubeSourceDataService.createPerspectiveData(perspective);
        return await self.makeRequest(
            "exportPerspective",
            options,
            undefined,
            undefined,
            pd,
            perspective.CubePerspectiveOptions,
            tableOptions,
        );
    }

    async exportPerspectiveOptions(
        cubeSource: ICubeSource,
        perspectiveOptions: ICubePerspectiveOptions,
        tableOptions: IHRTableModelOptions,
        options: IExportOptions,
    ): Promise<number> {
        const self = this;
        const pd = await CubeSourceDataService.createPerspectiveDataUsingOptions(cubeSource, perspectiveOptions);
        return await self.makeRequest(
            "exportPerspective",
            options,
            undefined,
            undefined,
            pd,
            perspectiveOptions,
            tableOptions,
        );
    }

    private async makeRequest(
        methodId: string,
        aExportOptions?: IExportOptions,
        json?: any,
        aMetricParamSet?: IMetricParameterSet,
        perspectiveData?: ICubeSourcePerspectiveData,
        perspectiveOptions?: ICubePerspectiveOptions,
        tableOptions?: IHRTableModelOptions,
    ): Promise<number> {
        const self = this;

        const aRequest: IExportRequestPayload = {
            method: methodId,
            exportOptions: aExportOptions || {},
        };
        if (!_.isUndefined(json)) aRequest.json = json;
        if (!_.isUndefined(aMetricParamSet)) aRequest.metricParamSet = aMetricParamSet;

        if (!_.isUndefined(perspectiveData)) aRequest.perspectiveData = perspectiveData;
        if (!_.isUndefined(perspectiveOptions)) aRequest.perspectiveOptions = perspectiveOptions;
        if (!_.isUndefined(tableOptions)) aRequest.tableOptions = tableOptions;

        let sEndPoint = <string>PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/");
        if (sEndPoint.endsWith("/")) sEndPoint += "export";
        else sEndPoint += "/export";

        const resp = await axios.post(sEndPoint, { data: { request: aRequest } });
        const responseData = resp.data;

        if (_.isNumber(responseData)) {
            self._OnExportCompleted.next(self);
            return _.toNumber(responseData);
        } else {
            throw "Unable to parse return value; unexpected type";
        }
    }
}
